import { cn } from "../lib/utils"

function Skeleton({ className, ...props }) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-[var(--ds-radius-surface)] bg-muted/70 motion-reduce:animate-none", className)}
      {...props}
    />
  )
}

export { Skeleton }
